import Certificate1 from "../../../Assets/Certificate/Certificate1.png"
import Certificate2 from "../../../Assets/Certificate/Certificate2.png"
export const DistributionDatas = [
  { value: 1048, name: "18-25" },
  { value: 735, name: "26-30" },
  { value: 580, name: "31-35" },
]

export const PostData = [
  { label: "All Post", value: "All Post" },
  { label: "Police Constable", value: "Police Constable" },
  { label: "Cadet Sub Inspector", value: "Cadet Sub Inspector" },
  { label: "Cadet ASP", value: "Cadet ASP" },
]
export const ActionAllOption = [
  { label: "Send Call Letter for Physical", value: "Send Call Letter for Physical", type: "all" },
  { label: "Send Call letter for CBT", value: "Send Call letter for CBT", type: "all" },
  { label: "Send Call letter for medical", value: "Send Call letter for medical", type: "all" },
  { label: "Send Appointment Letter", value: "Send Appointment Letter", type: "all" },
  { label: "Reject Application(s)", value: "Reject Application(s)", type: "inprocess" },

]
export const ActionOption = [
  { label: "Reject Application(s)", value: "Reject Application(s)" }
]
export const GenderOptions = [
  { label: "Male", value: "Male" },
  { label: "Female", value: "Female" }
]



export const ConstableData = [
  {
    ID: "004",
    applicationId:"NPSC-PC-001",
    name: "Temitope Adeyemi",
    roleApplied: "Police Constable",
    jobLocation:"Lagos, Nigeria",
    state: "Edo",
    city: "Benin City",
    gender: "Female",
    salutation:"Mr.",
    address:" 12, Victoria Island,  Lagos,Nigeria",

    contactnumber: "+234 701 234 5678",
    appliedOn: 1731442800000,
    updatedOn: 1721442800000,
    appliedOnCreatedBy: "Mr. Anto Raj",
    CreateorContactNumber: "+234 621 123 5123",
    CreatorMail:"anto@gmail.com",
    salary:100000,
    Hours:"10:00 AM to 5:00 PM",
    notificationNumer:"23/2024",
    Period:6,
    status: "Rejected",
    rejectedReason: "Identity Mismatch",
    email: "temitope.adeyemi@email.com",
    venue:"National Police Academy",
    benchMark:50,
    marksObtain:"50",
    RegisterNumber:"PSC1235249",
    user_type: "pc"
  },
  {
    ID: "005",
    name: "Folake Balogun",
    roleApplied: "Cadet ASP",
    state: "Kano",
    city: "Kano City",
    gender: "Male",
    contactnumber: "+234 701 234 5678",
    appliedOn: 1731432600000,
    updatedOn: 1721432600000,
    status: "Under Review",
    email: "folake.balogun@email.com",
    user_type: "pc"
  },
  {
    ID: "006",
    name: "Ikenna Nwachukwu",
    roleApplied: "Cadet Sub Inspector",
    state: "Ogun",
    city: "Abeokuta",
    gender: "Female",
    contactnumber: "+234 701 234 5678",
    appliedOn: 1731427200000,
    updatedOn: 1721427200000,
    status: "Finalised",
    email: "ikenna.nwachukwu@email.com",
    user_type: "pc"
  },
  {
    ID: "007",
    name: "Aisha Mohammed",
    roleApplied: "Cadet Sub Inspector",
    state: "Gombe",
    city: "Gombe",
    gender: "Female",
    contactnumber: "+234 701 234 5678",
    appliedOn: 1731423600000,
    updatedOn: 1721423600000,
    status: "Online Test",
    email: "aisha.mohammed@email.com",
    user_type: "pc"
  },
  {
    ID: "0010",
    name: "Zainab Usman",
    roleApplied: "Cadet Sub Inspector",
    state: "Osun",
    city: "Osogbo",
    gender: "Male",
    contactnumber: "+234 701 234 5678",
    appliedOn: 1731423600000,
    updatedOn: 1721423600000,
    status: "Medical Test",
    email: "zianab.mohammed@email.com",
    user_type: "pc"
  },
  {
    ID: "008",
    name: "Olumide Ogunbiyi",
    roleApplied: "Police Constable",
    state: "Osun",
    city: "Osogbo",
    gender: "Male",
    contactnumber: "+234 701 234 5678",
    appliedOn: 1731421800000,
    updatedOn: 1721421800000,
    status: "Rejected",
    rejectedReason: "Educational Qualification Not Met",
    email: "olumide.ogunbiyi@email.com",
    user_type: "pc"
  },
  {
    ID: "011",
    name: "Chinedu Okafor",
    roleApplied: "Police Constable",
    state: "Anambra",
    city: "Awka",
    gender: "Male",
    contactnumber: "+234 703 555 8899",
    appliedOn: 1731504000000,
    updatedOn: 1721504000000,
    status: "Under Review",
    email: "chinedu.okafor@email.com",
    user_type: "pc"
  },
  {
    ID: "012",
    name: "Adebayo Adesanya",
    roleApplied: "Cadet ASP",
    state: "Lagos",
    city: "Ikeja",
    gender: "Male",
    contactnumber: "+234 806 222 3344",
    appliedOn: 1731498000000,
    updatedOn: 1721498000000,
    status: "Rejected",
    rejectedReason: "Incomplete Documentation",
    email: "adebayo.adesanya@email.com",
    user_type: "pc"
  },
  {
    ID: "013",
    name: "Ngozi Nwankwo",
    roleApplied: "Cadet Sub Inspector",
    state: "Imo",
    city: "Owerri",
    gender: "Female",
    contactnumber: "+234 704 777 1234",
    appliedOn: 1731483600000,
    updatedOn: 1721483600000,
    status: "Finalised",
    email: "ngozi.nwankwo@email.com",
    user_type: "pc"
  },
  {
    ID: "014",
    name: "Yusuf Ibrahim",
    roleApplied: "Police Constable",
    state: "Kaduna",
    city: "Zaria",
    gender: "Male",
    contactnumber: "+234 803 111 4567",
    appliedOn: 1731470000000,
    updatedOn: 1721470000000,
    status: "Online Test",
    email: "yusuf.ibrahim@email.com",
    user_type: "pc"
  },
  {
    ID: "015",
    name: "Amaka Eze",
    roleApplied: "Cadet Sub Inspector",
    state: "Enugu",
    city: "Enugu",
    gender: "Female",
    contactnumber: "+234 805 444 9988",
    appliedOn: 1731462000000,
    updatedOn: 1721462000000,
    status: "Medical Test",
    email: "amaka.eze@email.com",
    user_type: "pc"
  },
  {
    ID: "016",
    name: "Samuel Akintunde",
    roleApplied: "Cadet ASP",
    state: "Ekiti",
    city: "Ado-Ekiti",
    gender: "Male",
    contactnumber: "+234 810 987 6543",
    appliedOn: 1731456000000,
    updatedOn: 1721456000000,
    status: "Rejected",
    rejectedReason: "Age Criteria Not Met",
    email: "samuel.akintunde@email.com",
    user_type: "pc"
  }
];

export const ApplicationHistoryData = [
  { application_id: "NPSC005", postname: "Police Constable" },
  { application_id: "NPSC007", postname: "West African Senior School Cert." },
  { application_id: "NPSC007", postname: "West African Senior School Cert." },
]

export const AgeDistriputionData = [
  { "label": "Abia", "value": "Abia", "age": 25, "gender": "male", "role": "constable" },
  { "label": "Adamawa", "value": "Adamawa", "age": 20, "gender": "female", "role": "cadetsi" },
  { "label": "Akwa Ibom", "value": "Akwa Ibom", "age": 23, "gender": "male", "role": "cadeasp" },
  { "label": "Anambra", "value": "Anambra", "age": 30, "gender": "female", "role": "constable" },
  { "label": "Bauchi", "value": "Bauchi", "age": 19, "gender": "male", "role": "constable" },
  { "label": "Bayelsa", "value": "Bayelsa", "age": 32, "gender": "female", "role": "constable" },
  { "label": "Benue", "value": "Benue", "age": 28, "gender": "male", "role": "cadetsi" },
  { "label": "Borno", "value": "Borno", "age": 35, "gender": "female", "role": "cadetsi" },
  { "label": "Cross River", "value": "Cross River", "age": 22, "gender": "female", "role": "cadeasp" },
  { "label": "Delta", "value": "Delta", "age": 27, "gender": "female", "role": "constable" },
  { "label": "Ebonyi", "value": "Ebonyi", "age": 24, "gender": "male", "role": "cadetsi" },
  { "label": "Edo", "value": "Edo", "age": 21, "gender": "female", "role": "cadeasp" },
  { "label": "Ekiti", "value": "Ekiti", "age": 26, "gender": "male", "role": "constable" },
  { "label": "Enugu", "value": "Enugu", "age": 19, "gender": "female", "role": "cadetsi" },
  { "label": "Gombe", "value": "Gombe", "age": 29, "gender": "male", "role": "cadeasp" },
  { "label": "Imo", "value": "Imo", "age": 31, "gender": "female", "role": "constable" },
  { "label": "Jigawa", "value": "Jigawa", "age": 22, "gender": "male", "role": "cadetsi" },
  { "label": "Kaduna", "value": "Kaduna", "age": 33, "gender": "female", "role": "cadeasp" },
  { "label": "Kano", "value": "Kano", "age": 28, "gender": "male", "role": "constable" },
  { "label": "Katsina", "value": "Katsina", "age": 30, "gender": "female", "role": "cadetsi" },
  { "label": "Kebbi", "value": "Kebbi", "age": 24, "gender": "male", "role": "cadeasp" },
  { "label": "Kogi", "value": "Kogi", "age": 21, "gender": "female", "role": "constable" },
  { "label": "Kwara", "value": "Kwara", "age": 25, "gender": "male", "role": "cadetsi" },
  { "label": "Lagos", "value": "Lagos", "age": 32, "gender": "female", "role": "cadeasp" },
  { "label": "Nasarawa", "value": "Nasarawa", "age": 27, "gender": "male", "role": "constable" },
  { "label": "Niger", "value": "Niger", "age": 26, "gender": "female", "role": "cadetsi" },
  { "label": "Ogun", "value": "Ogun", "age": 29, "gender": "male", "role": "cadeasp" },
  { "label": "Ondo", "value": "Ondo", "age": 23, "gender": "female", "role": "constable" },
  { "label": "Osun", "value": "Osun", "age": 20, "gender": "male", "role": "cadetsi" },
  { "label": "Oyo", "value": "Oyo", "age": 34, "gender": "female", "role": "cadeasp" },
  { "label": "Plateau", "value": "Plateau", "age": 32, "gender": "male", "role": "constable" },
  { "label": "Rivers", "value": "Rivers", "age": 21, "gender": "female", "role": "cadetsi" },
  { "label": "Sokoto", "value": "Sokoto", "age": 27, "gender": "male", "role": "cadeasp" },
  { "label": "Taraba", "value": "Taraba", "age": 35, "gender": "female", "role": "constable" },
  { "label": "Yobe", "value": "Yobe", "age": 24, "gender": "male", "role": "cadetsi" },
  { "label": "Zamfara", "value": "Zamfara", "age": 19, "gender": "female", "role": "cadeasp" },
  { "label": "Abia", "value": "Abia", "age": 25, "gender": "male", "role": "constable" },
  { "label": "Adamawa", "value": "Adamawa", "age": 20, "gender": "female", "role": "cadetsi" },
  { "label": "Akwa Ibom", "value": "Akwa Ibom", "age": 23, "gender": "male", "role": "cadeasp" },
  { "label": "Anambra", "value": "Anambra", "age": 30, "gender": "female", "role": "constable" },
  { "label": "Bauchi", "value": "Bauchi", "age": 19, "gender": "male", "role": "cadetsi" },
  { "label": "Bayelsa", "value": "Bayelsa", "age": 32, "gender": "female", "role": "cadeasp" },
  { "label": "Benue", "value": "Benue", "age": 28, "gender": "male", "role": "constable" },
  { "label": "Borno", "value": "Borno", "age": 35, "gender": "female", "role": "cadetsi" },
  { "label": "Cross River", "value": "Cross River", "age": 22, "gender": "male", "role": "cadeasp" },
  { "label": "Delta", "value": "Delta", "age": 27, "gender": "female", "role": "constable" },
  { "label": "Ebonyi", "value": "Ebonyi", "age": 24, "gender": "male", "role": "cadetsi" },
  { "label": "Edo", "value": "Edo", "age": 21, "gender": "female", "role": "cadeasp" },
  { "label": "Ekiti", "value": "Ekiti", "age": 26, "gender": "male", "role": "constable" },
  { "label": "Enugu", "value": "Enugu", "age": 19, "gender": "female", "role": "cadetsi" },
  { "label": "Gombe", "value": "Gombe", "age": 29, "gender": "male", "role": "cadeasp" },
  { "label": "Imo", "value": "Imo", "age": 31, "gender": "female", "role": "constable" },
  { "label": "Jigawa", "value": "Jigawa", "age": 22, "gender": "male", "role": "cadetsi" },
  { "label": "Kaduna", "value": "Kaduna", "age": 33, "gender": "female", "role": "cadeasp" },
  { "label": "Kano", "value": "Kano", "age": 28, "gender": "male", "role": "constable" },
  { "label": "Katsina", "value": "Katsina", "age": 30, "gender": "female", "role": "cadetsi" },
  { "label": "Kebbi", "value": "Kebbi", "age": 24, "gender": "male", "role": "cadeasp" },
  { "label": "Kogi", "value": "Kogi", "age": 21, "gender": "female", "role": "constable" },
  { "label": "Kwara", "value": "Kwara", "age": 25, "gender": "male", "role": "cadetsi" },
  { "label": "Lagos", "value": "Lagos", "age": 32, "gender": "female", "role": "cadeasp" },
  { "label": "Nasarawa", "value": "Nasarawa", "age": 27, "gender": "male", "role": "constable" },
  { "label": "Niger", "value": "Niger", "age": 26, "gender": "female", "role": "cadetsi" },
  { "label": "Ogun", "value": "Ogun", "age": 29, "gender": "male", "role": "cadeasp" },
  { "label": "Ondo", "value": "Ondo", "age": 23, "gender": "female", "role": "constable" },
  { "label": "Osun", "value": "Osun", "age": 20, "gender": "male", "role": "cadetsi" },
  { "label": "Oyo", "value": "Oyo", "age": 34, "gender": "female", "role": "cadeasp" },
  { "label": "Plateau", "value": "Plateau", "age": 32, "gender": "male", "role": "constable" },
  { "label": "Rivers", "value": "Rivers", "age": 21, "gender": "female", "role": "cadetsi" },
  { "label": "Sokoto", "value": "Sokoto", "age": 27, "gender": "male", "role": "cadeasp" },
  { "label": "Taraba", "value": "Taraba", "age": 35, "gender": "female", "role": "constable" },
  { "label": "Yobe", "value": "Yobe", "age": 24, "gender": "male", "role": "cadetsi" },
  { "label": "Zamfara", "value": "Zamfara", "age": 19, "gender": "female", "role": "cadeasp" }
];


export const SubjectData = [
  { subject: "English Language", grade: "C5", },
  { subject: "Mathematics", grade: "C4" },
  { subject: "Civil Education", grade: "C4" },
  { subject: "Biology", grade: "C5" },
  { subject: "Chemistry", grade: "C5" },
  { subject: "Physics", grade: "C6" },
  { subject: "Computer Studies", grade: "C7" },
]

export const PhysicalData = [
  { "name": "Height (In Meters)", value: "", Placeholder: "Enter Height Value", type: "input",defaulValue:"1.68" },
  { "name": "Weight (In Kg)", value: "", Placeholder: "Enter Weight Value", type: "input" ,defaulValue:"76"},
  { "name": "BMI Status", value: "", Placeholder: "BMI Status", type: "input" ,defaulValue:"23.5"},
  { "name": "Systolic Pressure", value: "", Placeholder: "Enter Systolic Pressure Value", type: "input",defaulValue:"120 mmHg" },
  { "name": "Diastolic Pressure", value: "", Placeholder: "Enter Diastolic Pressure", type: "input" ,defaulValue:"80 mmHg"},
  { "name": "Blood Group", value: "", Placeholder: "Select Blood Group", type: "dropdown" ,defaulValue:"O+"},
]
export const MedicalData = [
  { "name": "Height (In Meters)", value: "", Placeholder: "Enter Height Value", type: "input",defaulValue:"1.68" },
  { "name": "Weight (In Kg)", value: "", Placeholder: "Enter Weight Value", type: "input" ,defaulValue:"76"},
  { "name": "BMI Status", value: "", Placeholder: "BMI Status", type: "input" ,defaulValue:"23.5"},
  { "name": "Systolic Pressure", value: "", Placeholder: "Enter Systolic Pressure Value", type: "input",defaulValue:"120 mmHg" },
  { "name": "Diastolic Pressure", value: "", Placeholder: "Enter Diastolic Pressure", type: "input" ,defaulValue:"80 mmHg"},
  { "name": "Blood Group", value: "", Placeholder: "Select Blood Group", type: "dropdown" ,defaulValue:"O+"},
]

export const steps = [
  { label: "Job Application" },
  { label: "Physical Test", },
  { label: "Computer Based Test", },
  { label: "Medical screening", },
  { label: "Final Results & Appointment " },
];
export const EducationDetails = {
  "Level": "Secondary",
  "CourseName": "West African Senior School Certificate Examination",
  "SchoolName": "Government Secondary School",
  "StartedOn": "24 Jun 2012",
  "FinishedOn": "24 Jun 2013",
  "PassedSitting": "1 Sitting",
  "CertificateNumber": "SD234CDS",
  "CertificateAttachment": "View Certificate",
  "Phone1": "+234 80 3282 8796",
  "Phone2": "+234 81 4676 7173",
  "FullName1": "YAHAYA SHU",
  "FullName2": "ZAINABA MINU MUHAMMAD",
  "Address1": "Darmanawa Quarter, Behind Aminu Kano Teaching Hospital, Tarauni Local Government, Kano State, Nigeria",
  "Address2": "Hotoro, Ramin Kwalabe, Kano State, Nigeria"
}

export const BloodGroupList = [
  { value: "O+", label: "O+" },
  { value: "O-", label: "O-" },
  { value: "A+", label: "A+" },
  { value: "A-", label: "A-" },
  { value: "B+", label: "B+" },
  { value: "B-", label: "B-" },
  { value: "AB+", label: "AB+" },
  { value: "AB-", label: "AB-" }
];

export const ApplicationBasicDetails = {
  title: "Mr.",
  surname: "Nwafor",
  lastname: "Nwafor",
  "Othername": "Uchechukwu",
  "Gender": "Male",
  "dob": "15 Jul 1990",
  "MaritalStatus": "Single",
  "StateOfOrigin": "Lagos",
  "LocalGovernmentArea": "Ikeja",
  "MainPhoneNumber": "+234 80 1234 5678",
  "OtherPhoneNumber": "+234 80 1234 5678",
  "Email": "chijioke.nwafor@email.com",
  "Religion": "Muslim",
  "LanguagesSpoken": "English",
  "OtherLanguagesSpoken": ["French", "Spanish", "Arabic"],
  "Hobbies": ["JUGGING", "FOOT BALL"],
  "PermanentHomeAddress": "12, Victoria Island, Lagos",
  "PresentResidentialAddress": "15, Lekki Phase 1, Lagos",
  "fullName": "YUSIF ISHAQ DALAWA",
  "Occupation": "Farmer",
  "Relationship": "Father",
  "RegisterNumber": "PSC1235249",
  "Remarks": "Remarks Added to show the candidates ability"

}

export const AppointmentDataOtherInfomarion = [
  { name: "Job Location", value: "", Placeholder: "Enter Job Location", type: "input" ,defaultValue:"Lagos, Nigeria"},
  { name: "Job Start Date", value: "", Placeholder: "Select Job Start Date", type: "date" ,defaultValue:"1734759850000"},
  { name: "Monthly Salary", value: "", Placeholder: "Enter Monthly Salary", type: "input",defaultValue:"80000" },
  { name: "Probation Period", value: "", Placeholder: "Enter Probation Period", type: "input",defaultValue:"6 Months" },
  { name: "Working Hours", value: "", Placeholder: "Select Working Hours", type: "hour" ,defaultFromValue:"1734759922000",defaultToValue:"1734769922000"},
]

export const QualificationLevelData = [
  { level: "WASSCE/SSCE", certificateNumber: "12345678AB", status: null,verified:false,unVerified:false,url:Certificate1 },
  { level: "Bachelor of Science in Biology", certificateNumber: "UNI/ABC/12345", status: null,verified:false,unVerified:false ,url:Certificate2},
]

export const CandiateDetaildData = [
  { level: "Candidate Having Required Credit in English Language in WASSCE Mentioned in Application Form? (C4/C5)", No: false,Yes:false },
  { level: "Candidate Having Required Credit in Mathematics in WASSCE Mentioned in Application Form? (C4/C5)", No: false,Yes:false },
]

export const PhysicalDataDetails =[
  { label: "Height (In Meters)", value: "1.68 Meters", Pass: false, Fail: false, inputtype: "input",Yes:false,No:false },
  { label: "Weight (In Kg)", value: "76 Kgs", Pass: false, Fail: false, inputtype: "input",Yes:false,No:false },
  { label: "Chest Length (Unexpanded - in inches)", value: "29 inches", Pass: false, Fail: false, inputtype: "input",Yes:false,No:false },
  { label: "Chest Length (Expanded - in inches)", value: "31 Inches", Pass: false, Fail: false, inputtype: "input" ,Yes:false,No:false},
  { label: "Dental Condition", value: "Healthy", Pass: false, Fail: false, inputtype: "input",Yes:false,No:false },
  { label: "Do you have flat feet?", value: "No", Pass: false, Fail: false, inputtype: "checkbox" ,Yes:false,No:false},
  { label: "Do you have squinting eyes?", value: "No", Pass: false, Fail: false, inputtype: "checkbox" ,Yes:false,No:false},
  { label: "Do you have bow legs?", value: "No", Pass: false, Fail: false, inputtype: "checkbox",Yes:false,No:false },
]

export const CanditateApplicationData = [
  {
    ID: "004",
    applicationId:"NPSC-PC-001",
    name: "Temitope Adeyemi",
    roleApplied: "Police Constable",
    jobLocation:"Lagos, Nigeria",
    state: "Edo",
    city: "Benin City",
    gender: "Female",
    salutation:"Mr.",
    address:"12, Victoria Island,  Lagos,Nigeria",
    contactnumber: "+234 701 234 5678",
    appliedOn: 1731442800000,
    updatedOn: 1721442800000,
    status: "Rejected",
    email: "temitope.adeyemi@email.com",
    "RegisterNumber": "PSC1235249",
  },
  {
    ID: "005",
    applicationId:"NPSC-ASP-001",
    name: "Folake Balogun",
    roleApplied: "Cadet ASP",
    state: "Kano",
    city: "Kano City",
    gender: "Male",
    contactnumber: "+234 701 234 5678",
    appliedOn: 1731432600000,
    updatedOn: 1721432600000,
    status: "Under Review",
    email: "folake.balogun@email.com",
    user_type: "pc"
  },
  {
    ID: "006",
    applicationId:"NPSC-SI-0088",
    name: "Ikenna Nwachukwu",
    roleApplied: "Cadet Sub Inspector",
    state: "Ogun",
    city: "Abeokuta",
    gender: "Female",
    contactnumber: "+234 701 234 5678",
    appliedOn: 1731427200000,
    updatedOn: 1721427200000,
    status: "Finalised",
    email: "ikenna.nwachukwu@email.com",
    user_type: "pc"
  }
 
];